import { TSelectorTabItem } from 'shared/ui';

export const broadcastTypeOptions: TSelectorTabItem<boolean | undefined>[] = [
  { caption: 'Все трансляции', key: 'all', value: undefined },
  { caption: 'Только Live', key: 'live', value: true },
];
